var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"OfferBulkEdit"}},[_c('BulkEditor',{attrs:{"columns":_vm.columns,"source":_vm.formattedOffers,"validate-row":_vm.validateRow,"loading":_vm.loading,"resource-name":{
      singular: _vm.$t('campaignEdit.bulkEdit.offer'),
      plural: _vm.$t('campaignEdit.bulkEdit.offers')  
    },"allow-delete":true,"allow-copy":false,"allow-create":false},on:{"view-row":_vm.viewRow,"commit":_vm.saveOfferChanges,"discard":_vm.onDiscard},scopedSlots:_vm._u([{key:"col:valueType",fn:function(ref){
    var item = ref.item;
return [_vm._v("\n      "+_vm._s(item.label)+"\n    ")]}},{key:"col:promoType",fn:function(ref){
    var item = ref.item;
return [_vm._v("\n      "+_vm._s(item.label)+"\n    ")]}},{key:"col:isDisabled",fn:function(ref){
    var item = ref.item;
return [_vm._v("\n      "+_vm._s(item.label)+"\n    ")]}},{key:"col:language",fn:function(ref){
    var item = ref.item;
return [_vm._v("\n      "+_vm._s(item.label)+"\n    ")]}},{key:"col:notionalValue",fn:function(ref){
    var rawValue = ref.rawValue;
return [_c('Formatter',{attrs:{"type":"currency","currency":_vm.campaign.currency,"value":rawValue}})]}},{key:"col:minPurchase",fn:function(ref){
    var rawValue = ref.rawValue;
return [(rawValue >= 0)?_c('Formatter',{attrs:{"type":"currency","currency":_vm.campaign.currency,"value":rawValue}}):[_vm._v("—")]]}},{key:"col:maxRewards",fn:function(ref){
    var value = ref.value;
    var rawValue = ref.rawValue;
return [_vm._v("\n      "+_vm._s(rawValue > 0 ? value : _vm.$t('None'))+"\n    ")]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }